// extracted by css-extract-rspack-plugin
module.exports =  {"root":"BookkeepingManagerDetails__root___mglLK"};